import { BtBackendProvider } from './../../providers/bt-backend/bt-backend';
import { AlertController, LoadingController } from 'ionic-angular';
import { AdminProvider } from './../../providers/admin/admin';
import { Observable } from 'rxjs/Observable';
import { Subscription as rxSub } from 'rxjs/Subscription';

import { User, Subscription } from './../../models/User';
import { Component, Input } from '@angular/core';
import { UserProvider } from '../../providers/user/user';

@Component({
  selector: 'admin-user-subscription',
  templateUrl: 'admin-user-subscription.html'
})
export class AdminUserSubscriptionComponent {
  @Input('user') user: User;

  subscription: Subscription;
  rxSub: rxSub;


  constructor(
    public admin: AdminProvider,
    public alertCtrl: AlertController,
    public userCtrl: UserProvider,
    public backend: BtBackendProvider,
    public loadCtrl: LoadingController
  ) {

  }

  ngOnInit(){
    this.rxSub = this.admin.getSubscription(this.user.uid).subscribe((subscription) => {
      this.subscription = subscription
    });
  }

  ngOnDestroy(){
    this.rxSub.unsubscribe();
  }

  setRefId(){
    let alert = this.alertCtrl.create({
      title: 'Set Ref ID',
      subTitle: 'Only use this if the refId is not set or is NONE. Only works for transactions going forward',
      inputs: [
        {
          type: 'string',
          name: 'refId',
        }
      ],
      buttons: [
        {
          text: 'OK',
          handler: (data) => {
            if(data.refId){
              let id = this.getRefIdFromInput(data.refId);
              if(id){
                let loader = this.loadCtrl.create();
                loader.present();
                this.backend
                .adminSetReferralId(this.user.uid, id)
                .first()
                .subscribe(response => {
                  loader.dismiss();
                }, error => {
                  console.log(error);
                  loader.dismiss();
                })
              }
            }
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  getRefIdFromInput(id: string): string{
    if(id.indexOf('fp_ref') != -1){
      return this.userCtrl.parseUrlForRefId(id);
    }else{
      return id;
    }
  }

  canSetPro(){
    //ACTIVE : Paid and reset when not paid
    //INACTIVE: No subscription set, unpaid
    //UNPAID: Subscription set but not paid 
    //PRO: Access to data which must be terminated manually

    return this.subscription 
        && this.subscription.status === 'INACTIVE';
  }

  canRevokePro(){
    return this.subscription && this.subscription.status === 'PRO';
  }

  setPro(){
    this.admin.setPro(this.user.uid, true);
  }

  revokePro(){
    this.admin.setPro(this.user.uid, false);
  }

}



// WEBPACK FOOTER //
// ./src/components/admin-user-subscription/admin-user-subscription.ts